<template>
  <fragment>
    <v-container fluid pa-0>
      <v-layout justify-center column fill-height>
        <v-layout row fill-height>
          <v-radio-group v-model="input['genre_flag']" name="genre_flag" row hide-details>
            <v-radio color="primary" :value="0">
            </v-radio>
            <v-flex sm5>
              <CRow>
                <CCol class="py-0">
                  <SelectField
                          v-model="input['genre_id']"
                          name="genre_id"
                          :options="genres"
                          text-key="label"
                          value-key="value"
                          :multiple="false"
                  />
                </CCol>
              </CRow>
            </v-flex>
            <v-radio color="primary" :value="1">
            </v-radio>
            <v-flex sm4>
              <CRow>
                <CCol class="py-0">
                  <TextField
                          v-model="input['genre_name']"
                          :mode="mode"
                          name="genre_name"
                          remarks=""
                          placeholder="フリーワード"
                          :withLabel="true"
                  />
                </CCol>
              </CRow>
            </v-flex>
          </v-radio-group>
        </v-layout>
      </v-layout>
    </v-container>

  </fragment>
</template>

<script>
import TextField from "./text";
import SelectField from "./select";

export default {
  components: {
    TextField,
    SelectField
  },
  props: {
    input: {
      type: Object,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
    genres() {
      return this.$store.getters[`common/genres/options/options`] || [];
    }
  },
  created(){
    this.$store.dispatch(`common/genres/options/index`);
  }
};
</script>
<style module lang="scss">
.content-card {
  margin: 5px 0;
}
</style>
<style scoped>
.v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-right: 0px;
    margin-left: 20px;
    height: 32px;
}
</style>
